<template>
  <div class="card bg-white" style="height: 100vh;">
    <BehfamLOGO name="اتصال ناموفق!" style="position:absolute; right: 50%; top: 40%;"/>
    <button @click="checkServerConnection" style="position:absolute; right: 47%; top: 60%;" class="btn btn-submit-1 btn-primary">
      تلاش مجدد
    </button>
  </div>
</template>

<script>
import {defineComponent} from "vue";
import BehfamLOGO from "@/components/Icons/BehfamLOGO.vue";
import {useToast} from "vue-toastification";

const toast = useToast();

export default defineComponent({
  components: {BehfamLOGO},
  methods: {
    checkServerConnection() {
      fetch(`${this.base_url}/health-check`, { method: 'GET' })
          .then(response => {
            if (response.ok) {
              toast.info("اتصال برقرار است!"); // اینجا می‌توانید به جای alert هر عملیاتی را که می‌خواهید انجام دهید
              this.$router.go('/')
            } else {
              throw new Error('Failed to connect');
            }
          })
          .catch((error) => {
            toast.error("ارتباط با سرور برقرار نشد.");
          });
    }
  }
});
</script>
